import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class MapTool extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
						
		var mapTool = this;
		setTimeout(function(){
			mapTool.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var mapTool = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'point',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:map-marker', ' Add Point')
					], 
					listeners: {
						click: function() {
							actionAddPoint();
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'point',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:road', ' Add Route')
					], 
					listeners: {
						click: function() {
							actionRoute();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'features',
					'class': 'spacer-toolbar-item',
					style: 'width: 225px;',
					permissions: [],
					children:[
						ElementUtil.makeIcon('vaadin:cogs', ' Features')
					],
					properties: {
						menu: [
							{
								tag: 'vaadin-item',						
								innerHTML: 'Toggle POI Locations',
								listeners: {
									click: function(event) {
										map.togglePOILocations();
									}
								}
							},
							{
								tag: 'vaadin-item',						
								innerHTML: 'Toggle Commerical Places',
								listeners: {
									click: function(event) {
										map.togglePlaces();
									}
								}
							},
							{
								tag: 'vaadin-item',						
								innerHTML: 'Toggle 3D Buildings',
								listeners: {
									click: function(event) {
										map.toggle3dBuildings();
									}
								}
							}							
						]
					}					
				},
				{
					tag: 'dl-action-button',					
					'class': 'spacer-toolbar-item',
					style: 'width: 225px;',
					permissions: [],
					children:[
						ElementUtil.makeIcon('vaadin:cogs', ' View')
					],
					properties: {
						menu: [
							{
								tag: 'vaadin-item',						
								innerHTML: 'Show Satellite',
								listeners: {
									click: function(event) {
										map.showSatellite();
									}
								}
							},
							{
								tag: 'vaadin-item',						
								innerHTML: 'Show Terrain',
								listeners: {
									click: function(event) {
										map.showTerrain();
									}
								}
							},
							{
								tag: 'vaadin-item',						
								innerHTML: 'Show Transportation',
								listeners: {
									click: function(event) {
										map.showTransportation();
									}
								}
							}
							
						]
					}					
				}
				
			]
		});	
		
		var map = ElementUtil.create({
			tag: 'dl-map-panel',
			slot: 'primary',
			style: 'width: 100%; height: 100%',
			singleSearch: true
		});
				
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				map				
			]
		});				
		
		mapTool.append(flexLayout);
		
		var actionAddPoint = function() {
			var addWin = ElementUtil.create({			
				tag: 'dl-dialog',
				title: 'Add Point',
				icon: 'vaadin:upload',				
				width: 500,
				height: 200,
				listeners: {
					ready: function() {						
						addWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',							
							itemid: 'form',
							children: [
								{
									tag: 'dl-location-lookup',											
									textstyle: 'width: 300px',
									required: true											
								},
								{
									tag: 'vaadin-form-layout',										
									children: [																
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:plus', ' Add')
													],
													listeners: {
														click: function() {

															if (formPanel.isValid()) {
																var data = formPanel.getData();
																
																var loadMask = formPanel.showLoading('Geocoding...');
																RoutingService.getRoutingToolsService().geocode({
																	rawLocation: data.location
																}).then(function(results) {
																	loadMask.remove();
																	
																	results.forEach(function(result) {
																		var longLats = [result.longitude, result.latitude];
																		map.addMarker(longLats);
																	});
																	addWin.close();
																});
															}			
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',									
													listeners: {
														click: function() {
															addWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});					
						
						addWin.addToContentElement(formPanel);
												
					}
				}
			});
			
		};
		
		var actionRoute = function() {
			var addWin = ElementUtil.create({			
				tag: 'dl-dialog',
				title: 'Add Route',
				icon: 'vaadin:upload',				
				width: 500,
				height: 250,
				listeners: {
					ready: function() {						
						addWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',							
							itemid: 'form',
							children: [
								{
									tag: 'dl-location-lookup',			
									itemId: 'startLocation',
									textstyle: 'width: 300px',
									name: 'startLocation',
									required: true											
								},
								{
									tag: 'br'
								},
								{
									tag: 'dl-location-lookup',											
									itemId: 'endLocation',
									textstyle: 'width: 300px',
									name: 'endLocation',
									required: true											
								},
								{
									tag: 'vaadin-form-layout',										
									children: [																
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:plus', ' Add')
													],
													listeners: {
														click: function() {

															if (formPanel.isValid()) {
																var data = formPanel.getData();
																
																var loadMask = formPanel.showLoading('Geocoding...');
																RoutingService.getRoutingToolsService().geocode({
																	rawLocation: data.startLocation
																}).then(function(startArray) {																	
																	var start = startArray[0];
																	
																	if (!start.latitude || !start.longitude) {											
																		ElementUtil.query(formPanel, 'startLocation').markError('Invaild location');
																		loadMask.remove();
																	} else {										
																		RoutingService.getRoutingToolsService().geocode({
																			rawLocation: data.endLocation
																		}).then(function (endArray) {
																			var end = endArray[0];							
																			if (!end.latitude || !end.longitude) {											
																				ElementUtil.query(formPanel, 'endLocation').markError('Invaild location');
																				loadMask.remove();
																			} else {
																				loadMask.remove();
																				
																				var request = {
																					routeId: ElementUtil.nextId(),
																					stops: [
																					]
																				};						
																				request.stops.push({
																					longitude: start.longitude,
																					latitude: start.latitude
																				});
																				request.stops.push({
																					longitude: end.longitude,
																					latitude: end.latitude
																				});
																					
																				map.route(request);

																				addWin.close();
																				
																			}
																		});
																	}
																	
																});
															}			
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',									
													listeners: {
														click: function() {
															addWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});					
						
						addWin.addToContentElement(formPanel);
												
					}
				}
			});
			
		};
		
	}
	
}
customElements.define('dl-map-tool', MapTool);